"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const chunk_1 = require("../chunk/chunk");
const rule_1 = require("../translator/rule/rule");
const peg = require("pegjs");
class Renderer {
    constructor(chunk) {
        this.tracer = null;
        this.initializer = `
            {
                const { actions } = options;
                const globalFunction = {
                    location,
                    text
                };
            }
        `;
        this.start = chunk;
        this.grammar = new Map();
        this.grammar.set("initializer", this.initializer);
        this.rules = new Map();
        this.actions = new Map();
    }
    render() {
        this.collectRule(this.start);
        const grammar = [...this.grammar.values()].join("\n\n");
        return grammar;
    }
    collectRule(chunk) {
        if (!chunk_1.isChunk(chunk)) {
            return;
        }
        if (chunk.rule) {
            const translator = new rule_1.RuleTranslator();
            const ruleStr = translator.translate(chunk, this.actions);
            const { name, chunkOutput, rule } = translator.cache;
            if (this.rules.has(name)) {
                return;
            }
            this.rules.set(name, rule);
            this.grammar.set(name, ruleStr);
            this.collectRule(chunkOutput);
        }
        chunk.children.forEach(child => {
            this.collectRule(child);
        });
    }
}
class Parser {
    constructor(renderer) {
        this.renderer = renderer;
        this.grammar = this.renderer.render();
        this.parser = peg.generate(this.grammar, { trace: Boolean(renderer.tracer) });
    }
    parse(code) {
        try {
            const options = { actions: this.renderer.actions };
            if (this.renderer.tracer) {
                /**
                 * Tracing with peg.js: https://gist.github.com/mistlog/3ac6fdf7de3e7af2da15b339b4bb5187
                 */
                options.tracer = this.renderer.tracer;
            }
            const ast = this.parser.parse(code, options);
            return ast;
        }
        catch (error) {
            throw { message: error.message, location: error.location, stack: error.stack };
        }
    }
}
function render(chunk, config = {}) {
    const renderer = new Renderer(chunk);
    if (config.tracer) {
        renderer.tracer = config.tracer;
    }
    const parser = new Parser(renderer);
    return parser;
}
exports.render = render;
